// extracted by mini-css-extract-plugin
export default {"root":"SignInDetail_root__8VUCA","body":"SignInDetail_body__qfv6O"};